import React from "react";
import { useTable } from "../../Components/useTable";

const SvipList = () => {
  const type = "All Svip";
  const headCells = [
    { id: "name", numeric: false, label: "Name" },
    { id: "svip_no", numeric: false, label: "Svip No" },
    { id: "vipPrices", numeric: false, label: "Price" },
    { id: "MiniProfile", numeric: false, label: "Mini Profile Colorful" },
    { id: "canKick", numeric: false, label: "Can Kick" },
    { id: "canMute", numeric: false, label: "Can Mute" },
    { id: "bulletMessage", numeric: false, label: "Public Bullet Message" },
    { id: "privateBulletMessage", numeric: false, label: "Private Bullet Message" },
    { id: "canLive", numeric: false, label: "Live Option" },
    { id: "picture", numeric: false, label: "Frame" },
    { id: "animationUrl", numeric: false, label: "Entry Effect" },
    { id: "pictureUrl", numeric: false, label: "Batch" },
    { id: "tagImage", numeric: false, label: "Background" },
    { id: "adminImage", numeric: false, label: "Colorful Nickname" },
    { id: "created", numeric: false, label: "Date" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default SvipList;
